module.exports = __webpack_public_path__ + "img/blog2.a88dfde.png";